import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePartnerOwnerSummary = () => {
  const query = useQuery({
    queryKey: [QueryKeys.PARTNER_OWNER_SUMMARY],
    queryFn: () => accountRepo.getPartnerOwnerSummary(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UsePartnerOwnerSummary = ReturnType<typeof usePartnerOwnerSummary>;
